import { Outlet } from "react-router-dom";
import { Provider } from "urql";

import { FullPageSpinner } from "@/components/Spinner";
import { RealtimeProvider } from "@/context/realtime/provider";
import { ViewerContextProvider } from "@/context/viewer/provider";
import { useAuth } from "@/hooks/useAuth";
import { useGraphQLClient } from "@/hooks/useGraphQLClient";
import { useViewerContext } from "@/hooks/useViewerContext";

const AuthorizedRoute = () => {
    const client = useGraphQLClient();

    return (
        <Provider value={client}>
            <ViewerContextProvider>
                <RealtimeProvider>
                    <Inner />
                </RealtimeProvider>
            </ViewerContextProvider>
        </Provider>
    );
};

const Inner = () => {
    const { signOut } = useAuth();
    const { viewer, error, loading } = useViewerContext();

    if (loading) {
        return <FullPageSpinner />;
    }

    if (error) {
        return (
            <div className="mt-20 flex flex-col items-center space-y-5">
                <div className="text-center">
                    Something went wrong.. <br />
                    Please try again later! <br />
                    Error: {error.message}
                </div>
                <button onClick={signOut} className="rounded bg-blue-200 px-4 py-2">
                    Log out
                </button>
            </div>
        );
    }

    if (!viewer?.isEditor) {
        return (
            <div className="mt-10 flex flex-col items-center space-y-2">
                <div>You aren't an editor</div>
                <button onClick={signOut} className="rounded bg-blue-200 px-4 py-2">
                    Log out
                </button>
            </div>
        );
    }

    return <Outlet />;
};

export default AuthorizedRoute;
